import { ClienteDto } from '@desio/api';
import Riepilogo from 'components/riepilogo';
import Text from 'components/text';
import { dateFormat, dateTimeFormat } from 'helpers/utils';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Table } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getAvvioCertificazione, getDettaglioCliente, getElencoCertificazioniCliente, getFlagButtonAvviaCertificazione, resetResultAvvioCertificazione } from './_redux/actions';
import { clienteDtoSelector, elencoCertificazioniClienteSelector, flagButtonAvviaCertificazioneSelector, resultAvvioCertificazioneSelector } from './_redux/selectors';



interface RouteParams {
  ndg: string,
}

const DettaglioClienteCedacri: React.FC = () => {

  const history = useHistory();
  const dispatch = useAppDispatch();
  const elencoCertificazioniCliente = useAppSelector(elencoCertificazioniClienteSelector);
  // const dettaglioCertif = useAppSelector(dettaglioCertificazione)
  const { ndg } = useParams<RouteParams>();
  const dettaglioCliente: ClienteDto | undefined = useAppSelector(clienteDtoSelector);
  const flagAvviaCertificazione = useAppSelector(flagButtonAvviaCertificazioneSelector);
  const resultAvvioCertificazione = useAppSelector(resultAvvioCertificazioneSelector);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [modalAvviaCertificazione, setModalAvviaCertificazione] = useState<boolean>(false);


  useEffect(() => {
    if (ndg) {
      dispatch(getElencoCertificazioniCliente(parseInt(ndg)));
      dispatch(getDettaglioCliente(parseInt(ndg)));
      dispatch(getFlagButtonAvviaCertificazione(parseInt(ndg)));
    }
  }, [dispatch, ndg]);

  const dettaglioCertificazioneBtn = (id: number) => {
    history.push(`/admin/ricerca/${ndg}/${id}`)
  }

  const avviaCertificazione = () => {
    if (flagAvviaCertificazione?.idCertificazioneEmailAvviaCertificazione) {
      dispatch(getAvvioCertificazione(flagAvviaCertificazione.idCertificazioneEmailAvviaCertificazione));
    }
  }

  useEffect(() => {
    if (resultAvvioCertificazione) {
      setModalAvviaCertificazione(false)
      setShowSuccessModal(true)
      dispatch(getFlagButtonAvviaCertificazione(parseInt(ndg)));
      dispatch(resetResultAvvioCertificazione());
      dispatch(getDettaglioCliente(parseInt(ndg)));
      dispatch(getElencoCertificazioniCliente(parseInt(ndg)));
      setTimeout(() => {
        setShowSuccessModal(false)
      }, 3000);
    }
  }, [resultAvvioCertificazione])


  return (
    <div>
      <Row className="mb-3">
        <Col>
          <Text title="Dettaglio certificazioni cliente" type='sottotitolo' />
        </Col>
      </Row>

      {dettaglioCliente && (
        <Row className="mb-3">
          <Col md={12} lg={3}>
            <Riepilogo chiave='Ndg' valore={dettaglioCliente?.ndg} />
          </Col>
          <Col md={12} lg={3}>
            <Riepilogo chiave='Nominativo' valore={dettaglioCliente?.nominativo} />
          </Col>
          <Col md={12} lg={3}>
            <Riepilogo chiave='Data inserimento' valore={dateFormat(dettaglioCliente?.dataInserimento)} />
          </Col>
        </Row>
      )}

      <Row className="mb-3">
        <Col className="text-center">
          {flagAvviaCertificazione?.hasAvviaCertificazione && <Button onClick={() => setModalAvviaCertificazione(true)}>Avvia Certificazione</Button>}
          <hr />
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Table className="small" hover striped bordered responsive size="sm">
            <thead>
              <tr>
                <th>Id</th>
                <th>Modalità certificazione</th>
                <th>Stato certificazione</th>
                <th>Processo</th>
                <th>Campagna</th>
                <th>Email anagrafe</th>
                <th>Email firma biometrica</th>
                <th>Cellulare anagrafe</th>
                <th>Data ultima modifica</th>
                <th>Data certificazione</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {elencoCertificazioniCliente.map((arr, index) => (
                <tr key={index}>
                  <td>{arr.id}</td>
                  <td>{arr.modalitaCertificazioneDesc}</td>
                  <td>{arr.statoCertificazioneDesc}</td>
                  <td>{arr.workFlowCertificazioneNome}</td>
                  <td>{(arr.isCertificazioneFromLotto ?? false) ? "Sì" : "No"}</td>
                  <td>{arr.emailAnagrafe}</td>
                  <td>{arr.emailFirmaBiometricaAnagrafe || '-'}</td>
                  <td>{arr.cellulareAnagrafe}</td>
                  <td>{dateTimeFormat(arr.dataUltimaModifica)}</td>
                  <td>{dateTimeFormat(arr.dataCertificazione)}</td>
                  <td className="icon-table">
                    <Button variant="link" className="p-0" onClick={() => arr.id ? dettaglioCertificazioneBtn(arr.id) : null}>
                      <i className="fas fa-search-plus" title="Dettaglio"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
      <Modal
        show={showSuccessModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Text title="Certificazione avviata con successo" type="titolo"></Text>
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
              <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={modalAvviaCertificazione}
        onHide={() => setModalAvviaCertificazione(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Avvia Certificazione</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sei sicuro di voler avviare la certificazione?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={avviaCertificazione}>Avvia Certificazione</Button>
          <Button variant="secondary" onClick={() => setModalAvviaCertificazione(false)}>Chiudi</Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default DettaglioClienteCedacri;
